import { render } from "./tasks-left.vue?vue&type=template&id=2734dcfa"
import script from "./tasks-left.vue?vue&type=script&lang=js"
export * from "./tasks-left.vue?vue&type=script&lang=js"

import "./tasks-left.vue?vue&type=style&index=0&id=2734dcfa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__